import { API } from '../../constant/apiConstant';
export const BANK_PROCESSING_NOTICE = 'With your consent, FlipLottery shares your name, bank code and account number with QoreID to verify your bank account and account holder identity. We retain the verified name and verification reference. Bank verification does not verify your age; you must declare that you are 18 or older. Historical verification records remain subject to our Privacy Policy. Bank-name matching alone does not establish who is operating the account or independently verify legal identity. Additional assurance is required before withdrawals.';
export async function identityRequest(path, body) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch(`${API.BASE_URL}${path}`, { method: body ? 'POST' : 'GET', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' }, signal: controller.signal,
      ...(body ? { body: JSON.stringify(body) } : {}) });
    const data = await response.json();
    if (!response.ok || !data.status) throw Object.assign(new Error(data.message || 'Verification is unavailable. Please try again.'),{fields:data.fields});
    return data;
  } catch (error) {
    if (error.name === 'AbortError') throw new Error('Verification timed out. Do not resubmit immediately; resume the status check or contact support.');
    throw error;
  } finally { clearTimeout(timer); }
}
